import { render, staticRenderFns } from "./TableBranceImages.vue?vue&type=template&id=3e84bae8"
import script from "./TableBranceImages.vue?vue&type=script&lang=js"
export * from "./TableBranceImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports